<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn class="mx-0 px-0" v-on="on" icon :loading="loading" @click="openCollector">
        <v-icon :class="{ throbGlow: animate }">mdi-bug</v-icon>
      </v-btn>
    </template>
    <span>Report a Bug</span>
  </v-tooltip>
</template>

<style scoped>
.throbGlow {
  color: #ff5252;
  transform-origin: center;
  animation: throbGlow 1.2s ease-in-out infinite;
}

@keyframes throbGlow {
  0%,
  100% {
    transform: scale(1);
    text-shadow:
      0 0 6px #ff5252,
      0 0 12px #ff5252;
    opacity: 1;
  }
  50% {
    transform: scale(1.15); /* throb bigger */
    text-shadow:
      0 0 20px #ff5252,
      0 0 40px #ff5252;
    opacity: 0.9;
  }
}

/* Accessibility: respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .throbGlow {
    animation: none;
  }
}
</style>

<script>
export default {
  name: "BugButton",
  props: {},
  data: () => ({
    loading: false,
    showCollector: null,
    currentEnv: []
  }),
  computed: {
    user() {
      return this.$store.state.user;
    },
    animate() {
      return this.$store.state.animateBugButton;
    }
  },
  mounted() {
    this.collectEnv();
    // 1) Define props BEFORE loading the script
    window.ATL_JQ_PAGE_PROPS = {
      customTrigger: true,
      triggerFunction: showCollectorDialog => {
        this.showCollector = showCollectorDialog;
      },
      fieldValues: () => ({
        summary: ``,
        description: ``,
        environment: this.currentEnv,
        fullname: this.user?.name,
        email: this.user?.userName
      })
    };

    // 2) Load the collector script once
    this.loading = true;
    const s = document.createElement("script");
    s.src = process.env.VUE_APP_JIRA_COLLECTOR_URL;
    s.async = true;
    s.onload = () => {
      this.loading = false;
    };
    s.onerror = () => {
      this.loading = false;
    };
    document.body.appendChild(s);
  },
  methods: {
    openCollector() {
      if (this.showCollector) {
        this.collectEnv();
        this.showCollector(); // opens Jira’s dialog
      } else {
        this.mounted && this.mounted();
      }
    },
    collectEnv() {
      const dpr = window.devicePixelRatio;
      const { width, height } = window.screen || {};
      const { innerWidth, innerHeight } = window;

      this.currentEnv = [
        `App version: ${process.env.VUE_APP_VERSION}`,
        `Page: ${location.href}`,
        `UA: ${navigator.userAgent}`,
        `Lang: ${navigator.language}`,
        `TZ: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
        `Online: ${navigator.onLine}`,
        `Viewport: ${innerWidth}x${innerHeight} @${dpr}x`,
        `Screen: ${width}x${height}`,
        `Referrer: ${document.referrer || "(none)"}`,
        `Cookies enabled: ${navigator.cookieEnabled}`
      ].join("\n");

      if (window.ATL_JQ_PAGE_PROPS && window.ATL_JQ_PAGE_PROPS.fieldValues) {
        window.ATL_JQ_PAGE_PROPS.fieldValues.environment = this.currentEnv;
      }
    }
  }
};
</script>
